(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ColorPalette"] = factory();
	else
		root["ColorPalette"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1172);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(128);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 1172:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1173);


/***/ }),

/***/ 1173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paprika_tokens__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paprika_tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__paprika_tokens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_d3_scaleOrdinal__ = __webpack_require__(1176);




var color = __WEBPACK_IMPORTED_MODULE_2__paprika_tokens___default.a.color;

var ColorPalette = /*#__PURE__*/function () {
  function ColorPalette() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ColorPalette);

    this.colorRange = Object(__WEBPACK_IMPORTED_MODULE_3__vendor_d3_scaleOrdinal__["a" /* default */])().range(this.orderedColors());
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ColorPalette, [{
    key: "build",
    value: function build(colorMapping, colorByFieldName, key) {
      var mappedColor = this._map(colorMapping, colorByFieldName, key);

      var generatedColor = this._generate(key);

      return mappedColor || generatedColor;
    }
  }, {
    key: "_map",
    value: function _map(colorMapping, colorByFieldName, key) {
      var mappedColor = colorMapping[colorByFieldName + key];
      return mappedColor;
    }
  }, {
    key: "_generate",
    value: function _generate(key) {
      var index = this._getIndexByHashCode(key);

      var generatedColor = this.colorRange(index);
      return generatedColor;
    }
  }, {
    key: "_getIndexByHashCode",
    value: function _getIndexByHashCode(str) {
      var i = 0;
      var hash = 0;
      var salt = '1234567890qwertyuiopasdfghjklzxcvbnm';
      var strSalt = str + salt;

      for (i; i < strSalt.length; i++) {
        // eslint-disable-next-line no-bitwise
        hash = strSalt.charCodeAt(i) + ((hash << 5) - hash);
      }

      return hash % this.orderedColors().length;
    }
  }, {
    key: "baseColors",
    value: function baseColors() {
      return [color.chartColor04, color.chartColor05, color.chartColor11, color.chartColor10, color.chartColor09, color.chartColor08, color.chartColor07, color.chartColor01, color.chartColor02, color.chartColor03, color.chartColor12, color.chartColor06];
    }
  }, {
    key: "greyColors",
    value: function greyColors() {
      return [color.black, color.blackLighten20, color.blackLighten40, color.blackLighten60, color.white];
    }
  }, {
    key: "lightColors",
    value: function lightColors() {
      return ['#BCD2A8', '#94CDBD', '#BFE0E6', '#95C1DF', '#A9A9CF', '#DCB3C7', '#F6C2C7', '#E69EA2', '#E5C099', '#F5DDA8', '#E8E5E1', '#C6B6B4'];
    }
  }, {
    key: "lighterColors",
    value: function lighterColors() {
      return ['#E9F5DE', '#D6F0E9', '#EAF7FA', '#DDF0FD', '#E7E7F8', '#FAEEF4', '#FEECEE', '#FBE1E3', '#FBECDC', '#FFF8EA', '#FAF8F5', '#F0E4E2'];
    }
  }, {
    key: "darkColors",
    value: function darkColors() {
      return ['#396115', '#043F2F', '#358492', '#003D68', '#16125E', '#86164F', '#AE434D', '#82070E', '#784106', '#A26F00', '#A08E71', '#55271F'];
    }
  }, {
    key: "orderedColors",
    value: function orderedColors() {
      return [this.baseColors()[3], this.baseColors()[8], this.baseColors()[0], this.baseColors()[7], this.baseColors()[2], this.baseColors()[5], this.baseColors()[9], this.baseColors()[4], this.baseColors()[1], this.baseColors()[11], this.baseColors()[6], this.baseColors()[10]];
    }
  }, {
    key: "heatMapColors",
    value: function heatMapColors() {
      return [this.baseColors()[7], this.baseColors()[8], this.baseColors()[9], this.baseColors()[0], this.baseColors()[1]];
    }
  }, {
    key: "treemapColors",
    value: function treemapColors() {
      return [this.lighterColors()[3], this.baseColors()[3], this.darkColors()[3]];
    }
  }, {
    key: "mapChartColors",
    value: function mapChartColors() {
      return [this.baseColors()[1], this.baseColors()[0], this.baseColors()[9], this.baseColors()[8], this.baseColors()[7]];
    }
  }]);

  return ColorPalette;
}();

/* harmony default export */ __webpack_exports__["default"] = (ColorPalette);

/***/ }),

/***/ 1174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _tokens["default"];
  }
});

var _tokens = _interopRequireDefault(__webpack_require__(1175));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(0);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
var tokens = {
  "color": {
    "black": "#3f3d3c",
    "blackLighten10": "#575757",
    "blackLighten20": "#717171",
    "blackLighten30": "#8a8a8a",
    "blackLighten40": "#a4a4a4",
    "blackLighten50": "#bdbdbd",
    "blackLighten60": "#d7d7d7",
    "blackLighten70": "#f0f0f0",
    "blackLighten80": "#f7f7f7",
    "blackLighten90": "#fcfcfc",
    "blackDisabled": "#a4a4a4",
    "blackPure": "#000000",
    "blue": "#276cf5",
    "blueDarken20": "#004a94",
    "blueDarken10": "#0063c5",
    "blueLighten10": "#3396f9",
    "blueLighten20": "#66b0fa",
    "blueLighten30": "#99cbfc",
    "blueLighten40": "#cce5fd",
    "blueLighten50": "#e5f1fe",
    "creme": "#e6e3df",
    "cremeDarken30": "#a39889",
    "cremeDarken20": "#b9b1a6",
    "cremeDarken10": "#d0cac2",
    "cremeLighten5": "#f1f0ed",
    "cremeLighten10": "#fcfcfc",
    "green": "#42996d",
    "greenDarken10": "#337554",
    "greenDarken20": "#23523a",
    "greenLighten10": "#5db187",
    "greenLighten20": "#80c1a0",
    "greenLighten30": "#a2d2ba",
    "greenLighten40": "#c4e3d3",
    "greenLighten50": "#e7f3ed",
    "offWhite": "#f0f0f0",
    "orange": "#de4d33",
    "orangeDarken10": "#bf371f",
    "orangeDarken20": "#932b18",
    "orangeDarken30": "#671e11",
    "orangeLighten10": "#e07764",
    "orangeLighten20": "#e99c8e",
    "orangeLighten30": "#f1c1b9",
    "orangeLighten40": "#fae7e3",
    "orangeDisabled": "#e99c8e",
    "orangeHighlight": "#e1624b",
    "purple": "#785cba",
    "purpleDarken10": "#5f449f",
    "purpleDarken20": "#4a347c",
    "purpleLighten10": "#9884c5",
    "purpleLighten20": "#b5a7d5",
    "purpleLighten30": "#d2c9e6",
    "purpleLighten40": "#efecf6",
    "purpleLighten50": "#fbfafd",
    "white": "#ffffff",
    "yellow": "#eaba51",
    "yellowDarken10": "#e5a823",
    "yellowDarken20": "#be8a17",
    "yellowDarken30": "#916911",
    "yellowDarken40": "#63480c",
    "yellowLighten10": "#eccb82",
    "yellowLighten20": "#f3ddae",
    "yellowLighten30": "#f9f0db",
    "gold": "#f0a117",
    "silver": "#cfcfcf",
    "eggplant": "#2e143d",
    "eggplantLighten10": "#4b2164",
    "eggplantLighten20": "#682e8b",
    "eggplantLighten30": "#853AB1",
    "chartColor01": "#cd3c44",
    "chartColor02": "#cb8133",
    "chartColor03": "#eaba51",
    "chartColor04": "#79a551",
    "chartColor05": "#299a7a",
    "chartColor06": "#8c6d68",
    "chartColor07": "#ec848f",
    "chartColor08": "#b9668f",
    "chartColor09": "#785cba",
    "chartColor10": "#2b82bf",
    "chartColor11": "#7ec0cc",
    "chartColor12": "#d1cbc2"
  },
  "space": "8px",
  "spaceSm": "4px",
  "spaceLg": "12px",
  "placeholder": {
    "color": "#717171",
    "fontStyle": "italic"
  },
  "highlight": {
    "active": {
      "noBorder": {
        "boxShadow": "0 0 0 2px #99cbfc",
        "insetBoxShadow": "inset 0 0 0 2px #99cbfc",
        "borderColor": "#276cf5"
      },
      "withBorder": {
        "boxShadow": "0 0 0 1px #276cf5, 0 0 0 3px #99cbfc",
        "insetBoxShadow": "inset 0 0 0 1px #276cf5, inset 0 0 0 3px #99cbfc"
      },
      "nonInteractive": {
        "outline": "2px dotted #8a8a8a"
      }
    },
    "text": {
      "green": {
        "background": "#e7f3ed",
        "font": "#23523a"
      },
      "orange": {
        "background": "#fae7e3",
        "font": "#932b18"
      },
      "yellow": {
        "background": "#f7f3ba",
        "font": "#63480c"
      }
    }
  },
  "textColor": {
    "default": "#3f3d3c",
    "subtle": "#717171",
    "link": "#0063c5",
    "linkHover": "#004a94",
    "icon": "#717171"
  },
  "fontFamily": {
    "default": "\"Lato\", \"Helvetica Neue\", Helvetica, Arial, sans-serif",
    "jp": "\"Lato\", \"Helvetica Neue\", Helvetica, Arial, sans-serif, \"Hiragino Kaku Gothic Pro\", \"ヒラギノ角ゴ Pro W3\", \"ＭＳ Ｐゴシック\", \"MS PGothic\"",
    "kr": "\"Lato\", \"Helvetica Neue\", Helvetica, Arial, sans-serif, \"Malgun Gothic\"",
    "zh": "\"Helvetica Neue\", Helvetica, Arial, sans-serif, 黑體-繁, \"Heiti TC\", 儷黑Pro, \"LiHei Pro\", PMingLiu, 宋体, SimSun"
  },
  "table": {
    "header": {
      "backgroundColor": "#f0f0f0"
    },
    "row": {
      "backgroundColor": "#ffffff"
    },
    "rowEven": {
      "backgroundColor": "#f7f7f7"
    }
  },
  "border": {
    "radius": "3px",
    "color": "#d7d7d7",
    "hoverColor": "#a4a4a4",
    "colorTransition": "border-color 0.2s"
  },
  "button": {
    "borderRadius": "4px"
  },
  "card": {
    "borderRadius": "6px",
    "shadow": "0 0 0 1px rgba(63,61,60,0.05),0 1px 3px 0 rgba(63,61,60,0.15)"
  },
  "overlay": {
    "animationDuration": "700",
    "backdrop": {
      "backgroundColor": "rgba(63,61,60,0.5)"
    }
  },
  "modal": {
    "backgroundColor": "#ffffff",
    "borderRadius": "6px",
    "shadow": "0 8px 12px -4px rgba(63,61,60,0.2),0 1px 3px 0 rgba(63,61,60,0.1)",
    "sizes": {
      "sm": "450px",
      "md": "675px",
      "lg": "900px"
    },
    "margin": "24px",
    "top": "100px",
    "footer": {
      "backgroundColor": "#f7f7f7"
    }
  },
  "checkbox": {
    "sizeSm": "16px",
    "sizeMd": "20px",
    "sizeLg": "24px"
  },
  "radio": {
    "sizeSm": "16px",
    "sizeMd": "20px",
    "sizeLg": "24px"
  },
  "popover": {
    "borderRadius": "6px",
    "shadow": "0 2px 4px rgba(0,0,0,0.1)"
  },
  "counter": {
    "small": "17px",
    "medium": "19px"
  },
  "pill": {
    "smallRadius": "8px / 50%",
    "mediumRadius": "12px / 50%"
  },
  "backgroundColor": {
    "level0": "#f7f7f7"
  },
  "fontSize": {
    "default": "16px"
  },
  "shadow": "0px 1px 5px rgba(0,0,0,0.07),0px 7px 17px rgba(0,0,0,0.1)"
};
var _default = tokens;
exports["default"] = _default;
//# sourceMappingURL=tokens.js.map

/***/ }),

/***/ 1176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export implicit */
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable */
// src: https://github.com/d3/d3-scale/blob/43ca71c0950e15c4e2f3cecb8086a03d399f608c/src/ordinal.js
// Note: modified to remove dependency on initRange.
var implicit = Symbol('implicit');
function ordinal() {
  var index = new Map(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    var key = d + '',
        i = index.get(key);

    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }

    return range[(i - 1) % range.length];
  }

  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = new Map();

    var _iterator = _createForOfIteratorHelper(_),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;
        var key = value + '';
        if (index.has(key)) continue;
        index.set(key, domain.push(value));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return scale;
  };

  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), scale) : range.slice();
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function () {
    return ordinal(domain, range).unknown(unknown);
  };

  initRange.apply(scale, arguments);
  return scale;
}

function initRange(domain, range) {
  switch (arguments.length) {
    case 0:
      break;

    case 1:
      this.range(domain);
      break;

    default:
      this.range(range).domain(domain);
      break;
  }

  return this;
}

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(129);
var $Object = __webpack_require__(11).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(20), 'Object', { defineProperty: __webpack_require__(24).f });


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var core = __webpack_require__(11);
var ctx = __webpack_require__(54);
var hide = __webpack_require__(41);
var has = __webpack_require__(37);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(35)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 21:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(34);
var IE8_DOM_DEFINE = __webpack_require__(84);
var toPrimitive = __webpack_require__(58);
var dP = Object.defineProperty;

exports.f = __webpack_require__(20) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(27);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(24);
var createDesc = __webpack_require__(46);
module.exports = __webpack_require__(20) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 46:
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(73);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(27);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 73:
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(20) && !__webpack_require__(35)(function () {
  return Object.defineProperty(__webpack_require__(85)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(27);
var document = __webpack_require__(21).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ 9:
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ })

/******/ });
});
//# sourceMappingURL=ColorPalette.js.map